module.exports = __webpack_public_path__ + "img/water_yellow.a93a02ab.svg";